import IconShowMore from '@sympla/sympla-ui/lib/icons/iconShowMore';
import * as El from './ShowMoreCard.css';
import locales from './_locales/ShowMoreCard.json';

interface ShowMoreCardProps {
  cardType: El.CardType;
  lang: 'PT' | 'ES' | 'EN';
  href: string;
}

function ShowMoreCard({ cardType, lang = 'PT', href = '#' }: ShowMoreCardProps) {
  return (
    <a href={href} className={El.showMoreContainerVariant[cardType]}>
      <IconShowMore />
      <span className={El.text}>{locales[lang].SEE_MORE}</span>
      <div className={El.showMore}>{locales[lang].SHOW_MORE}</div>
    </a>
  );
}

export default ShowMoreCard;
